import { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import uuid from 'react-uuid';

import { scrollIntoView } from '../../../../../__util__/scroll';
import { logError } from '../../../../../api/errorLoggerApi';
import Error from '../../../../../Error/Error';
import { displayAPIError } from '../../utils/utils';

export function FormTemplateError(props) {
  const {
    source,
    handleLog,
    customErrorRef,
    formTemplateRequest,
    authenticityToken,
    customError,
    disableWrapperClass,
  } = props;
  const error = customError || formTemplateRequest.error;
  const { templateId, version_number } = useParams();
  const errorRef = customErrorRef || uuid();
  const formTemplateErrorRef = useRef(null);

  useEffect(() => {
    if (displayAPIError(error)) {
      scrollIntoView(formTemplateErrorRef, 'start');
      handleError();
    }
  }, [error]);

  const handleError = () => {
    if (handleLog) {
      const errorDetails = {
        log_type: 'FormTemplate_Error',
        log_reference: errorRef,
        log_message: error.name,
        error: error.message,
      };

      logError({
        authenticity_token: authenticityToken,
        severity: 'error',
        log: JSON.stringify(errorDetails),
      });
    }
  };

  const renderError = () => {
    const heroHeaderTitles = [
      {
        title: 'ERROR:',
        subTitle: '',
      },
    ];

    switch (source) {
      case 'api':
      case 'JSRuntime':
        heroHeaderTitles[0].subTitle = 'ChilliPharm Error';
        if ((displayAPIError(error) && source === 'api') || source === 'JSRuntime') {
          return (
            <Error
              heroHeaderTitles={heroHeaderTitles}
              errorReference={errorRef}
              errorMessage="Oh no! Something has gone wrong on our end."
            >
              We've got logs and we'll look into it, but you can be a star and help us out by logging a{' '}
              <a
                href="https://chillibean.atlassian.net/servicedesk/customer/portal/1/group/3/create/1"
                target="_blank"
                rel="noreferrer"
              >
                ticket
              </a>{' '}
              with the above error reference.
            </Error>
          );
        }
        return null;

      case 'templateId':
        heroHeaderTitles[0].subTitle = 'Invalid Form Template ID';
        return (
          <Error heroHeaderTitles={heroHeaderTitles} errorMessage={`Form Template ID (${templateId}) is not found`}>
            Perhaps you are here because:
            <ul>
              <li>This Form Templates does not exist</li>
              <li>This Form Template does exist but you typed in the wrong URL by accident.</li>
            </ul>
            Either way, go to <Link to="/">Form Templates</Link> (link) and choose an existing one.
          </Error>
        );

      case 'templateVersionId':
        heroHeaderTitles[0].subTitle = 'Invalid Form Template Version';
        return (
          <Error
            heroHeaderTitles={heroHeaderTitles}
            errorMessage={`Form Template Version (${version_number}) not found`}
          >
            Perhaps you are here because:
            <ul>
              <li>This Form Templates Version does not exist</li>
              <li>This Form Template Version does exist but you typed in the wrong URL by accident.</li>
            </ul>
            Either way, go to the <Link to={`/${templateId}/versions`}>Form Template</Link> (link) and choose an
            existing version.
          </Error>
        );
      default:
        return null;
    }
  };

  return (
    <>
      {renderError() ? (
        <div ref={formTemplateErrorRef} className={`${disableWrapperClass ? '' : 'template-builder_content-wrapper'}`}>
          {renderError()}
        </div>
      ) : null}
    </>
  );
}

function mapStateToProps(state) {
  return {
    formTemplateRequest: state.formTemplateApiReducer.formTemplateRequest,
    authenticityToken: state.internalReducer.internal.authenticityToken,
  };
}

export default connect(mapStateToProps)(FormTemplateError);
